import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

const i18nActionPointKeys = ['item1', 'item2', 'item3', 'item4'] as const
const mediaQuery = [
  { screen: '(max-width: 767px)', width: '640px' },
  { screen: '(max-width: 1024px)', width: '992px' },
  { screen: '(min-width: 1025px)', width: '1280px' },
]
export default function WhyChoose({ className = '' }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')

  return (
    <div className={`${className}`}>
      <div className="max-w-3xl mx-auto">
        <h2 className="mb-4 text-lg sm:text-h3 font-semibold">
          <span className="bg-clip-text text-transparent bg-gradient-tod-heading">
            {t('landingPage.whyChoose.title')}
          </span>
        </h2>
        <ul className="list-disc text-black-light-fade pl-8 sm:text-menu leading-8 sm:leading-9">
          {i18nActionPointKeys.map((elem) => (
            <li key={elem}>
              {Trans({
                t,
                i18nKey: `landingPage.whyChoose.list.${elem}`,
                components: { strong: <strong className="font-semibold" /> },
                children: t(`landingPage.whyChoose.list.${elem}`),
              })}
            </li>
          ))}
        </ul>
      </div>

      <div className="pt-20 -mx-4 xl:-mx-12 mb-12 md:mb-6 overflow-hidden">
        <ResponsiveImage
          alt="House of Math Team"
          height={600}
          imageClassName="mx-auto xl:max-w-7xl"
          imageWidths="640, 992, 1280"
          mediaQuery={mediaQuery}
          srcKey="mentor-on-demand/home/why-choose/avatar-group.png"
          width={1280}
        />
      </div>
    </div>
  )
}
